/*!
 * Copyright (c) 2023 Digital Bazaar, Inc. All rights reserved.
 */
export const name = 'ecdsa-sd-2023';
